import { Badge, ProgressBar } from '@welbe/web-design-system';
import React from 'react';
import {
	CardItem,
	Container,
	ItemCategory,
	ItemDescription,
	ItemDomain,
	ItemTitle,
	ProgressContainer,
} from './RiskCard.styles';

export const RiskCard = ({ category }: any) => {
	return (
		<Container>
			<CardItem>
				<ItemCategory>
					<ItemTitle>Categoría</ItemTitle>
					<ItemDescription variant>{category.name}</ItemDescription>
				</ItemCategory>

				<ItemTitle domain>Dominio</ItemTitle>
				{category.domains.map(({ name, riskLevel }: any, index: number) => (
					<ItemDomain
						key={name}
						last={category.domains.length - 1 === index}
						first={index === 0}
					>
						<ItemDescription>{name}</ItemDescription>
						<Badge
							variant="primary"
							readonly
							backgroundColor={riskLevel.color}
							textColor={riskLevel.name === 'Medio' ? '#64778F' : '#FFF'}
							fontWeight={700}
							width="86px"
						>
							{riskLevel.name}
						</Badge>
					</ItemDomain>
				))}
			</CardItem>
			<ProgressContainer>
				<ProgressBar
					isDonut
					hasLabel
					labelText={category.riskLevel.name}
					labelFontSize="14px"
					labelColor="#64778F"
					progressColor={category.riskLevel.color}
					donutSize="60px"
					percentValue={100}
				/>
			</ProgressContainer>
		</Container>
	);
};
